import type { ChatWidgetProps } from '../types/chat';
import type { MigrationResult } from './migrate';

export type { MigrationChange, MigrationResult } from './migrate';

/**
 * Package export for integrators' own tooling (build scripts, admin consoles, codemods):
 * rewrites a v1 prop object into the canonical v2 `settings` shape. See `./migrate`.
 *
 * Async on purpose: the package entry is also the widget bundle, so the helper is loaded as a
 * separate chunk on first call instead of shipping to every page that embeds the widget.
 */
export function migrateWidgetProps(props: ChatWidgetProps): Promise<MigrationResult> {
  return import(/* webpackChunkName: "config-migrate" */ './migrate').then(mod =>
    mod.migrateWidgetProps(props)
  );
}
